export const NAMESPACE = 'mylounge';

export const EA_CAROUSEL_CAMPAIGNS_COUNT = 5;
export const EA_CAROUSEL_CAMPAIGNS_THRESHOLD = 4;

export const EA_UPCOMING_CAROUSEL_CAMPAIGNS_COUNT = 4;
